import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const emailChannel = defineChannel({
  id: 'email',
  icon: 'email',
  name: 'Email',
  shortName: 'email',
  noun: 'email',
  events: [
    'attempted',
    'sent',
    'delivered',
    'deferred',
    'failed',
    'bounced',
    'opened',
    'clicked',
    'converted',
    'drafted',
    'dropped',
    'undeliverable',
    'unsubscribed',
    'spammed',
    'topic_unsubscribed',
  ],
} as const satisfies ChannelDefinition);
